import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";

export function useOmiRoom(roomId) {
  const [room, setRoom] = useState(null);

  useEffect(() => {
    if (!roomId) {
      setRoom(null);
      return undefined;
    }

    return onSnapshot(doc(db, "omi_rooms", roomId), (snapshot) => {
      setRoom(snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : null);
    });
  }, [roomId]);

  return room;
}
